export default __webpack_public_path__ + "a1911fba456ed57ecb4938b4a261c758.png";